import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-black text-primary-500 tracking-wide">
              八戒影院
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              <a href="#footer-categories">影视分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.id !== 'all').map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              <a href="#footer-quick-links">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">关于我们</Link>
              <Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">联系我们</Link>
              <Link to="/category/movie" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">电影大全</Link>
              <Link to="/category/tv" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">电视剧全集</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>{siteInfo.email}</span>
              <span>{siteInfo.phone}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站所有资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}